import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class UniversityService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
     private _getUniversityAllUrl = APIURL+'University/getAllUniversity';
    private _getUniversityUrl = APIURL+'University/University';
    private _isActivelUrl = APIURL+'University/UniversityVerify';
    private _deleteUrl = APIURL+'University/deleteUniversity';
    private _addUrl = APIURL+'University/saveUniversity';
    private _getUniversityByIdUrl=APIURL+'University/getUniversityById';
     private _editUrl=APIURL+'University/updateUniversityById';
    
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
   
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    isUniversityActive(UniversityId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('universityId', UniversityId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    getAllUniversitys():any{
        return this._http.post(this._getUniversityAllUrl,[] )
                            .map((response: Response) => response.json().data)
    }
    getAllUniversitysById(UniversityId:string):any{
           let formData:FormData = new FormData();
         formData.append('UniversityId', UniversityId);
        return this._http.post(this._getUniversityByIdUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getUniversitys(userId:any): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getUniversityUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    add(form:any,UniPhoto):any{
           let formData:FormData = new FormData();
         formData.append('university_Name', form.UniversityName);
         formData.append('authoreEmail', form.UniversityEmail);
         formData.append('authoreAdd', form.UniversityAddress);
         formData.append('authorePhone', form.UniversityPhone);
         if(UniPhoto!=null){ 
              formData.append('UniversityPhoto', UniPhoto, UniPhoto.name);
          }
        formData.append('userId', this.currentUser.UserId+"");
        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    edit(form:any,UniPhoto):any{
           let formData:FormData = new FormData();
         formData.append('university_Name', form.UniversityName);
         formData.append('authoreEmail', form.UniversityEmail);
         formData.append('authoreAdd', form.UniversityAddress);
         formData.append('authorePhone', form.UniversityPhone);
         if(UniPhoto!=null){ 
              formData.append('UniversityPhoto', UniPhoto, UniPhoto.name);
          }
           formData.append('UniversityId', form.UniversityId);
           
        return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    
    delete(UniversityId): any{
           let formData:FormData = new FormData();
         formData.append('UniversityId',UniversityId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/university.service.ts